module.exports = {"340523100":"历阳镇","340523102":"白桥镇","340523103":"姥桥镇","340523104":"功桥镇","340523105":"西埠镇","340523106":"香泉镇","340523107":"乌江镇","340523108":"善厚镇","340523109":"石杨镇","340523400":"安徽和县经济开发区","340523401":"安徽精细化工产业有机合成基地","340523500":"安徽和县台湾农民创业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340523.json
// module id = 1078
// module chunks = 0